import React, { Component } from 'react';

class ModalConfirmarEliminacionRenglon extends Component {

    constructor(props) {
        super(props);
    }
    

    render() {
        const {
            nroRenglon,
            seAgregaRenglon
        } = this.props;

        //ACTIONS
        const {
            agregarEliminarRenglonContable,
            mostrarOcultarModalConfirmarEliminacionRenglon
        } = this.props;

        return (
            <div className='modalContainer'>
                <div className='modalDemandaOutXS'>
                    <div className='text-right'>
                        <label onClick={() => mostrarOcultarModalConfirmarEliminacionRenglon("modalConfirmarBorrarRenglon", false)} className='ti-close clickable ABMModelos__modalConfirmarEliminacionRenglon__botonCerrar'></label>
                    </div>

                    <div className='modalConfirmarSalirTexto'>
                        {"¿Está seguro de que desea eliminar el renglón " + nroRenglon + "?"}
                    </div>

                    <div className='modalProcesosFooterShort'>
                        <button onClick={() => mostrarOcultarModalConfirmarEliminacionRenglon("modalConfirmarBorrarRenglon", false)} className="btn btn-secondary">Cancelar</button>
                        <button className="btn btn-cta" onClick={() => agregarEliminarRenglonContable(nroRenglon, seAgregaRenglon, false)}>Confirmar</button>
                    </div>
                </div>
            </div>

        )
    }
}

export default ModalConfirmarEliminacionRenglon;
